import { Component, OnInit } from '@angular/core';
import { NutzerService } from '../service/nutzer.service';
import { ToastrService } from 'ngx-toastr';
import { StammService } from '../service/stamm.service';
import { SessionService } from '../service/session.service';
import * as sha1 from 'js-sha1';
import { isWebAuthnSupported } from '../utils/webauthn';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {



  public username = "";
  public password = "";
  public email = "";
  public mailIsSending = false;
  public mfaCode = "";
  public passkeySupported = isWebAuthnSupported();
  public setupMethode: 'MAIL' | 'TOTP' = 'MAIL';
  public setupCode = "";
  public totpSetup: {secret: string, qrDataUrl: string} | null = null;

  constructor(
    private nutzerService: NutzerService,
    private stammService: StammService,
    private toast: ToastrService,
    public sessionService: SessionService
  ) { }

  ngOnInit() {
  }
  public login() {
    if (this.username !== "" && this.password !== "") {
      this.sessionService.login(this.username, sha1(this.password));
      this.password = "";
    } else {
      this.toast.error("Keine gültigen Eingaben bei der Anmeldung!", "Üngültige Eingabe");
    }

  }

  public logout() {
    this.sessionService.logout();
    this.username = "";
  }

  public async loginWithPasskey() {
    await this.sessionService.loginWithPasskey();
  }

  public async verifyMfa() {
    if (this.mfaCode === "") {
      this.toast.error("Bitte den Code eingeben!", "Ungültige Eingabe");
      return;
    }
    await this.sessionService.verifyMfa(this.mfaCode);
    this.mfaCode = "";
  }

  public cancelMfa() {
    this.mfaCode = "";
    this.sessionService.cancelMfa();
  }

  public async onSetupMethodeChange() {
    this.setupCode = "";
    if (this.setupMethode === 'TOTP' && !this.totpSetup) {
      const setup = await this.sessionService.startTotpSetupForLogin();
      if (setup) {
        this.totpSetup = {secret: setup.secret, qrDataUrl: await QRCode.toDataURL(setup.otpauthUrl)};
      }
    }
  }

  public async completeMfaSetup() {
    if (this.setupMethode === 'TOTP' && this.setupCode === "") {
      this.toast.error("Bitte den Code aus der Authenticator-App eingeben!", "Ungültige Eingabe");
      return;
    }
    await this.sessionService.completeMfaSetup(this.setupMethode, this.setupCode);
    this.setupCode = "";
    if (!this.sessionService.mfaSetupChallenge) {
      this.resetMfaSetup();
    }
  }

  public async postponeMfaSetup() {
    await this.sessionService.postponeMfaSetup();
    if (!this.sessionService.mfaSetupChallenge) {
      this.resetMfaSetup();
    }
  }

  public cancelMfaSetup() {
    this.sessionService.cancelMfaSetup();
    this.resetMfaSetup();
  }

  private resetMfaSetup() {
    this.setupMethode = 'MAIL';
    this.setupCode = "";
    this.totpSetup = null;
  }

  public sendPasswordRecoveryMail() {
    if(this.mailIsSending){
      this.toast.warning("Es wird bereits eine E-Mail gesendet", "Bitte warten");
      return;
    }
    this.mailIsSending = true;
    this.nutzerService.sendPasswordRecoveryMail(this.email).then(() => {
      this.toast.success("Wenn die Adresse " + this.email + " im System hinterlegt ist, wurde jetzt eine E-Mail versendet.", "Passwort Wiederherstellung");
      this.email = "";
      this.mailIsSending = false;
    }
    ).catch(() => {
      this.toast.error("Es ist ein Fehler aufgetreten.", "Passwort Wiederherstellung");
      this.mailIsSending = false;
    });
  }

  public sendUsernameRecoveryMail() {
    if(this.mailIsSending){
      this.toast.warning("Es wird bereits eine E-Mail gesendet", "Bitte warten");
      return;
    }
    this.mailIsSending = true;
    this.nutzerService.sendUsernameRecoveryMail(this.email).then(() => {
        this.toast.success("Wenn die Adresse " + this.email + " im System hinterlegt ist, wurde jetzt eine E-Mail versendet.", "Benutzername Vergessen");
        this.email = "";
        this.mailIsSending = false;
      }
    ).catch(() => {
      this.toast.error("Es ist ein Fehler aufgetreten.", "Benutzername Vergessen");
      this.mailIsSending = false;
    });
  }
}
